/** 底部日期标签与 x 轴线的间距 */
export const DATE_AXIS_LABEL_MARGIN = 10;
/** 开启事件数量轴时，日期标签需下移避开事件徽章（与舆情 KeyMetrics 一致） */
export const DATE_AXIS_LABEL_MARGIN_WITH_EVENT = 26;

/** 底部日期标签默认灰色 */
export const OPINION_DATE_AXIS_LABEL_COLOR = '#838697';
/** hover 时日期标签高亮黑色 */
export const OPINION_DATE_AXIS_POINTER_LABEL_COLOR = '#262832';
/** 与图表背景一致，用于盖住下方灰色日期 */
export const OPINION_DATE_AXIS_POINTER_LABEL_BG = '#fff';

/**
 * 舆情折线图 hover 日期标签：
 * 用与背景同色的白底盖住灰色 axisLabel，再叠一层黑色加粗时间（同舆情 KeyMetrics）。
 */
export function buildOpinionDateAxisPointerLabel(margin: number): IRecord {
  return {
    show: true,
    backgroundColor: OPINION_DATE_AXIS_POINTER_LABEL_BG,
    borderWidth: 0,
    borderColor: 'transparent',
    shadowBlur: 0,
    shadowColor: 'transparent',
    // 略大于文字，确保完全盖住下方灰色日期
    padding: [1, 4],
    color: OPINION_DATE_AXIS_POINTER_LABEL_COLOR,
    fontWeight: 700,
    fontSize: 12,
    margin,
  };
}

/**
 * 底部日期轴标签：保留原 formatter，统一灰色与间距。
 */
export function buildOpinionDateAxisLabel({
  baseAxisLabel = {},
  showEventAxis,
}: {
  baseAxisLabel?: IRecord;
  showEventAxis: boolean;
}): IRecord {
  return {
    ...baseAxisLabel,
    color: baseAxisLabel.color || OPINION_DATE_AXIS_LABEL_COLOR,
    // 必须放在最后，避免被 base 覆盖
    margin: showEventAxis
      ? DATE_AXIS_LABEL_MARGIN_WITH_EVENT
      : DATE_AXIS_LABEL_MARGIN,
  };
}
